/* retail filter data  */
export const namespaced = true

export const state = {
    retailer_type:"All",
}

export const mutations = {
    SET_RETAILER_FILTER(state, {
        retailer_type,
    }) {
        state.retailer_type = retailer_type
    },
}
export const actions = {
    setRetailerFilter({
        commit
    }, items) {
        commit('SET_RETAILER_FILTER', items)
    },
}
export const getters = {
    getRetailerFilter: state => {
        return state;
    },
}